<template>
  <div class="about">
    <b-container>
		<b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="/ticketcop/img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col><br>
        </b-row>
        <br>
		
        <component-viewTicket v-if="showTicket" :idTicket="idTicket" :ticket="ticket"></component-viewTicket>
        <b-row v-if="showError">
         <b-col class="text-center">
            <h2> Error ticket could not be found ! </h2>
            </b-col>
        </b-row>
        <br>
     </b-container>
  </div>
</template>

<script>

import viewTicket from '../components/viewTicket.vue'
import axios from 'axios';

export default {
  name: 'viewTicket',
   
   components: {
    'component-viewTicket' : viewTicket
   },
  data: () => ({
        employee : "",
        idEmployee : -1,
        idticket : null,
        showTicket : false,
        showError : false,
        ticket : null
  }),
  methods: {
      
  },

   created: function () {
       var self = this;
       this.idTicket =  this.$route.params.idTicket;

       console.log( this.$route.params.idTicket);
       axios.get(localStorage.getItem('ticketCopURL') +'/viewSpecificTicket', {
            //axios.get('https://energydrive.dnsalias.com/ticketcop_dev/viewJobs', {
            params: {
                    idTicket : self.idTicket
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            console.log("Geting ticket from url");
            if ( response.data != "error" )
            {
                self.ticket = response.data[0];
                self.showTicket = true;
            }
            else
            {
                console.log("Error response");
                self.showError = true;
            }
            
            
            //mainObject.ticketTagSubCategory_visible = true;

            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
            // always executed
            console.log("Got all unresolved tickets for user from url");
            
            
            }); 
       

   }
}
</script>
